module.exports = __webpack_public_path__ + "img/5.77a6561e.jpg";